// Mobile
import { isConsumerApp } from '@loggi/js/mobile';
import Col from '@loggi/ui/components/col';
import Text, {
  TEXT_SIZE_REGULAR,
  TEXT_TYPE_TITLE
} from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import screens from '@loggi/ui/components/utils/screens';
import View from '@loggi/ui/components/view';
import ViewContainer from '@loggi/ui/components/view-container';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { packageTrackerModel } from 'public-tracker/public-tracker.models/package-tracker.model';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionsTracker from 'tracker.actions';
import {
  IS_PACKAGE_TRACKING_KEY_FORM,
  IS_PACKAGE_TRACKING_TOKEN_SCREEN
} from 'tracker.constants';
import { PATH_PACKAGE_TRACKING } from 'tracker.routes';
import { PackageTrackingFooter } from '../components/package-tracking-footer/package-tracking-footer.component';
import Buttons from './token-buttons/token-buttons.component';
import TokenInput from './token-input/token-input.component';

const screen = screens.getScreen();
const _isSmallScreen = isConsumerApp() || screen < screens.sizes.sm;

export class Token extends React.Component {
  static propTypes = {
    packageTracker: PropTypes.shape(packageTrackerModel).isRequired,
    actions: PropTypes.shape({
      savePhoneNumber: PropTypes.func.isRequired
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired
    }).isRequired,
    match: PropTypes.shape({
      companySecretId: PropTypes.shape({
        companyHash: PropTypes.string.isRequired
      }).isRequired,
      trackingKey: PropTypes.string.isRequired
    }).isRequired,
    mobilePhoneNumber: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this._updateMobilePhoneNumber = this._updateMobilePhoneNumber.bind(this);
    this._renderStatusComponent = this._renderStatusComponent.bind(this);
    this.state = {
      mobilePhoneNumber: props.mobilePhoneNumber,
      packageTracker: props.packageTracker
    };
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.savePhoneNumber({ mobilePhoneNumber: null });
  }

  _updateMobilePhoneNumber(newMobilePhoneNumber) {
    this.setState({
      mobilePhoneNumber: newMobilePhoneNumber
    });
  }

  _renderStatusComponent(
    mobilePhoneNumber,
    isMobilePhoneNumberAlreadyVerified = false
  ) {
    const { actions, history } = this.props;
    actions.savePhoneNumber({
      mobilePhoneNumber,
      isMobilePhoneNumberAlreadyVerified,
      shouldLoadQuery: false
    });
    const url = this._generateUrl();
    history.push(url);
  }

  _generateUrl() {
    const { match } = this.props;
    const { companySecretId: companyHash, trackingKey } = match.params;
    const url = `${PATH_PACKAGE_TRACKING}/${companyHash}/${trackingKey}`;
    return url;
  }

  render() {
    const { actions, history, postalCode } = this.props;
    const { mobilePhoneNumber, packageTracker } = this.state;
    const packageId = get(packageTracker, 'packageInfo.packageId', null);

    if (!mobilePhoneNumber) {
      actions.savePhoneNumber({
        shouldLoadQuery: true
      });
      history.push(PATH_PACKAGE_TRACKING);
      return null;
    }

    return (
      <ViewContainer fluid>
        <Col
          size={12}
          gutter={{
            xs: { top: 'triple' },
            md: { bottom: 'triple' },
            xxl: { left: 'double' }
          }}
          className="package-wrapper"
        >
          <Col
            flex
            flexDirection="column"
            size={{ md: 6, lg: 6, xl: 5, xxl: 4 }}
            gutter={{
              xs: { top: 'triple', left: 'double', right: 'double' },
              sm: { top: 'double' }
            }}
            className="main-content"
            backgroundColor={colors.type.WHITE}
            alignItems="center"
          >
            <View gutter={{ bottom: 'normal' }}>
              <Text type={TEXT_TYPE_TITLE}>
                {IS_PACKAGE_TRACKING_TOKEN_SCREEN.title}
              </Text>
            </View>
            <View size={IS_PACKAGE_TRACKING_KEY_FORM.subtitle.size}>
              <View
                gutter={{ xs: { bottom: 'onehalf' }, md: { bottom: 'double' } }}
                style={{ textAlign: 'center' }}
              >
                <Text size={TEXT_SIZE_REGULAR} color={colors.type.DARK}>
                  {IS_PACKAGE_TRACKING_TOKEN_SCREEN.subtitle}
                </Text>
              </View>
            </View>
            <View size={8}>
              <TokenInput
                mobileNumber={mobilePhoneNumber}
                packageId={packageId}
                callbackToRenderStatusComponent={this._renderStatusComponent}
              />
            </View>
            <View flexGrow="1" gutter={{ bottom: 'double' }}>
              <Buttons
                mobilePhoneNumber={mobilePhoneNumber}
                shouldStartTimer
                packageTracker={packageTracker}
                postalCode={postalCode}
                callbackToRenderStatusComponent={this._renderStatusComponent}
                updateMobilePhoneNumber={this._updateMobilePhoneNumber}
              />
            </View>
            <PackageTrackingFooter isSmallScreen={_isSmallScreen} />
          </Col>
        </Col>
      </ViewContainer>
    );
  }
}

Token.displayName = 'Token';

function mapStateToProps({ packageTracking }) {
  return packageTracking;
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actionsTracker, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Token);
